<script setup>
defineProps({ chapter: { type: Object, required: true } })
function safeUrl(value) {
  try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? url.href : null } catch { return null }
}
</script>

<template>
  <section class="chapter-body">
    <p v-if="chapter.purpose" class="chapter-purpose">{{ chapter.purpose }}</p>
    <p v-if="chapter.conclusion || chapter.summary"><strong>本章结论：</strong>{{ chapter.conclusion || chapter.summary }}</p>
    <p v-for="(paragraph, index) in chapter.paragraphs || []" :key="`paragraph-${index}`">{{ paragraph }}</p>
    <p v-if="chapter.body">{{ chapter.body }}</p>
    <article v-for="(point, index) in chapter.points || []" :key="`point-${index}`">
      <h4 v-if="point.title">{{ point.title }}</h4><p>{{ typeof point === 'string' ? point : point.body }}</p>
    </article>
    <div v-if="chapter.rows?.length" class="chapter-table" tabindex="0" aria-label="章节分析表，可横向滚动">
      <table><thead><tr><th v-for="(column, index) in chapter.columns || ['分析项', '分析内容', '建议行动']" :key="index" scope="col">{{ column }}</th></tr></thead>
        <tbody><tr v-for="(row, index) in chapter.rows" :key="index"><td v-for="(value, key) in row" :key="key">{{ value }}</td></tr></tbody>
      </table>
    </div>
    <template v-if="chapter.actions?.length"><h4>建议行动</h4><ol><li v-for="(action, index) in chapter.actions" :key="index">{{ action }}</li></ol></template>
    <p v-if="chapter.caveat"><strong>限制与待核验：</strong>{{ chapter.caveat }}</p>
    <template v-if="chapter.evidenceRefs?.length"><h4>本章引用依据</h4>
      <ul><li v-for="(source, index) in chapter.evidenceRefs" :key="index">
        <a v-if="safeUrl(source.url)" :href="safeUrl(source.url)" target="_blank" rel="noopener noreferrer">{{ source.title || source.url }}</a>
        <span v-else>{{ source.title || '未提供可打开的来源链接' }}</span>
        <span v-if="source.platform"> · {{ source.platform }}</span>
      </li></ul>
    </template>
  </section>
</template>

<style scoped>
.chapter-body{line-height:1.8;overflow-wrap:anywhere}.chapter-body p{white-space:pre-wrap}.chapter-body h4{margin:20px 0 8px}.chapter-purpose{color:#536b7d}.chapter-table{overflow-x:auto;margin:16px 0;max-width:100%}.chapter-table table{border-collapse:collapse;width:100%;min-width:480px}.chapter-table th,.chapter-table td{border:1px solid #dbe6ea;padding:10px;text-align:left;vertical-align:top;white-space:pre-wrap}.chapter-body a{color:#08746d;text-decoration:underline}.chapter-body li{margin:8px 0}
</style>
